var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpureZone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#136DEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2122 30.8056H18.1567V23.0278H29.8233V30.8056H31.7678V20.4514L23.99 17.3403L16.2122 20.4514V30.8056ZM14.2678 32.75V19.1389L23.99 15.25L33.7122 19.1389V32.75H27.8789V24.9722H20.1011V32.75H14.2678ZM21.0733 32.75V30.8056H23.0178V32.75H21.0733ZM23.0178 29.8333V27.8889H24.9622V29.8333H23.0178ZM24.9622 32.75V30.8056H26.9067V32.75H24.9622ZM18.1567 23.0278H23.99H29.8233H18.1567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpureZone);
export default __webpack_public_path__ + "static/media/impure-zone.93021272338cb954217bd32dcd16efe2.svg";
export { ForwardRef as ReactComponent };